import React, { Component } from 'react'
import Axios from 'axios';

class PersonInput extends Component {

    state = {
        persons: [],
        // id: 0,
        name: "",
        email: ""
    }

    handleSubmit = event => {
        event.preventDefault();
        const persons = {
            name: this.state.name,
            email: this.state.email
        };
        Axios.post('https://jsonplaceholder.typicode.com/users', persons)
        .then(res => {
            console.log(res);
            console.log(res.data);
            // this.setState({persons: res.data});
        })
        .catch(err => {
            console.log(err)
        });
    };

    // deleteUser = event => {
    //     const persons = {
    //         name: this.state.name,
    //         email: this.state.email
    //     };
    //     Axios.delete(`https://jsonplaceholder.typicode.com/users/${this.state.id}`)
    //     .then(res => {
    //         console.log(res);
    //         console.log(res.data);
    //     });
    // };

    handleChange = event => {
        this.setState({ 
            // [event.target.id]: event.target.value
            [event.target.name]: event.target.value,
            [event.target.email]: event.target.value
         });
    };

  render() {
      const { name, email } = this.state;

    return (
      <>
        <form
        className="ui form"
        onSubmit={this.handleSubmit}
        >
          <div className="field"
          style={{display: "inline-flex"}}
          >
            <label>Name:
              <input type="text"
                name="name"
                onChange={this.handleChange}
                value={name}
              />
            </label>
            <label>Email:
              <input type="text"
                name="email"
                onChange={this.handleChange}
                value={email}
              />
            </label>
            <button
            className="ui violet button"
            type="submit"
            >Add Items</button>
            {/* <label>Id:
              <input type="number"
                name="id"
              />
            </label>
            <button
            className="ui violet button"
            onClick={this.deleteUser()}
            >delete Items</button> */}
          </div>
        </form>

        {/* {
          persons.length ?
          persons.map(person => <div key={person.id}>
            {person.name}
          </div>) : null
          } */}
      </>
    )
  }
}

export default PersonInput;
